import axios, { AxiosRequestConfig } from 'axios'
import LocalStorage from '@storage/browser/LocalStorage'

export const getAxiosInstance = (appState: any) => {
    const storage = new LocalStorage()
    const { session } = appState
    const axiosConfig: AxiosRequestConfig = {
        baseURL: window.config.API_BASE_URL,
    }

    if (window.config?.APP_ENV !== 'local') {
        axiosConfig.headers = {
            Authorization: `${session.accessToken}`,
            'x-ibm-client-id': `${window.config?.SECURITY?.TOKEN_OAUTH_2_USER_ID?.CLIENT_ID}`,
            'Ocp-Apim-Subscription-Key': `${window.config.SUBSCRIPTION_KEY}`,
            'rut': `${JSON.parse( String( storage.get('userData') ) ).rutTEMP}`,
            'Cache-Control' : 'no-cache, no-store, must-revalidate, max-age=0' ,
            'Pragma': 'no-cache' ,
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains'
        }
    }

    return axios.create(axiosConfig)
}

export const getAxiosInstanceOAUTH = () => {
    const axiosConfig: AxiosRequestConfig = {
        withCredentials: true,
        baseURL: window.config.OAUTH_API_BASE_URL,
    }

    return axios.create(axiosConfig)
}
